import { useState } from 'react'
import { supabase } from './supabase'

function stripBrand(name, brand) {
  if (!brand || !name) return name || ''
  const escaped = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return name.replace(new RegExp('^' + escaped + '\\s*', 'i'), '').trim() || name
}

const ITEM_EMOJIS = [
  '🧅','🧄','🍅','🥬','🫑','🌶️','🥦','🍄','🥑','🍋','🍌','🍎','🍓','🫐','🍇','🍊',
  '🥕','🌽','🥒','🥔','🍠','🫛','🫘','🫚','🍗','🦃','🥓','🌭','🐟','🦐','🥩',
  '🥚','🧈','🧀','🥛','🫓','🥯','🥐','🍞','🥞','🧇','🍝','🍚','🫒','🧂','🍯',
  '🍲','🫙','🥫','🍿','🥣','☕','🍵','🧃','🥤','🍷','🍺','🍫','🍪','🥜','🍦','🧊',
  '🧴','🧻','🧽','🛒',
]

function getItemEmoji(item) {
  if (item.emoji && item.emoji !== '🛒') return item.emoji
  const n = (item.name || '').toLowerCase()
  if (/\bonion|shallot/.test(n)) return '🧅'
  if (/\bgarlic/.test(n)) return '🧄'
  if (/\btomato/.test(n)) return '🍅'
  if (/\blettuce|romaine|iceberg|arugula/.test(n)) return '🥬'
  if (/\bspinach|kale/.test(n)) return '🥬'
  if (/\bbell pepper|pepper/.test(n)) return '🫑'
  if (/\bjalape|chili|chile/.test(n)) return '🌶️'
  if (/\bbroccoli/.test(n)) return '🥦'
  if (/\bmushroom/.test(n)) return '🍄'
  if (/\bavocado/.test(n)) return '🥑'
  if (/\blemon|lime/.test(n)) return '🍋'
  if (/\bbanana/.test(n)) return '🍌'
  if (/\bapple/.test(n)) return '🍎'
  if (/\bstrawberr|raspberr/.test(n)) return '🍓'
  if (/\bblueberr/.test(n)) return '🫐'
  if (/\bgrape/.test(n)) return '🍇'
  if (/\borange/.test(n)) return '🍊'
  if (/\bcarrot/.test(n)) return '🥕'
  if (/\bcorn/.test(n)) return '🌽'
  if (/\bcucumber|zucchini/.test(n)) return '🥒'
  if (/\bcelery/.test(n)) return '🥬'
  if (/\bsweet potato|yam/.test(n)) return '🍠'
  if (/\bpotato/.test(n)) return '🥔'
  if (/\bsnap pea|pea/.test(n)) return '🫛'
  if (/\bbean/.test(n)) return '🫘'
  if (/\bginger/.test(n)) return '🫚'
  if (/\bchicken/.test(n)) return '🍗'
  if (/\bturkey/.test(n)) return '🦃'
  if (/\bbacon/.test(n)) return '🥓'
  if (/\bsausage|bratwurst/.test(n)) return '🌭'
  if (/\bsalmon|tilapia|cod|tuna|fish/.test(n)) return '🐟'
  if (/\bshrimp|prawn/.test(n)) return '🦐'
  if (/\bbeef|steak|chuck|ground/.test(n)) return '🥩'
  if (/\bpork|ham/.test(n)) return '🥩'
  if (/\begg|eggs/.test(n)) return '🥚'
  if (/\bbutter/.test(n)) return '🧈'
  if (/\bcheese|parmesan|mozzarella|cheddar/.test(n)) return '🧀'
  if (/\bmilk|cream|yogurt/.test(n)) return '🥛'
  if (/\btortilla|wrap/.test(n)) return '🫓'
  if (/\bbagel/.test(n)) return '🥯'
  if (/\bcroissant/.test(n)) return '🥐'
  if (/\bbread|loaf|roll|bun/.test(n)) return '🍞'
  if (/\bpita/.test(n)) return '🫓'
  if (/\bpancake|waffle/.test(n)) return '🥞'
  if (/\bpasta|spaghetti|noodle|penne|fettuccine|linguine/.test(n)) return '🍝'
  if (/\brice/.test(n)) return '🍚'
  if (/\bolive oil|oil/.test(n)) return '🫒'
  if (/\bsalt/.test(n)) return '🧂'
  if (/\bhoney/.test(n)) return '🍯'
  if (/\bbroth|stock|soup/.test(n)) return '🍲'
  if (/\bsalsa/.test(n)) return '🫙'
  if (/\bketchup/.test(n)) return '🍅'
  if (/\bpopcorn|chip|crisp/.test(n)) return '🍿'
  if (/\bcereal|oat/.test(n)) return '🥣'
  if (/\bcoffee/.test(n)) return '☕'
  if (/\btea/.test(n)) return '🍵'
  if (/\bjuice/.test(n)) return '🧃'
  if (/\bsoda|cola/.test(n)) return '🥤'
  if (/\bwine/.test(n)) return '🍷'
  if (/\bbeer/.test(n)) return '🍺'
  if (/\bchocolate|cocoa/.test(n)) return '🍫'
  if (/\bcookie|biscuit/.test(n)) return '🍪'
  if (/\bnut|almond|cashew|walnut|peanut/.test(n)) return '🥜'
  if (/\bice cream/.test(n)) return '🍦'
  if (/\bfrozen/.test(n)) return '🧊'
  if (/\bsoap|detergent|dish/.test(n)) return '🧴'
  if (/\bpaper towel|toilet|tissue/.test(n)) return '🧻'
  return '🛒'
}

export default function NewBundle({ user, onBack, onSaved, customTabs = [], initialName = '', initialEmoji = '🛒', initialCategory = 'dinner', initialItems = [], initialSourceUrl = '' }) {
  const [name, setName] = useState(initialName)
  const [emoji, setEmoji] = useState(initialEmoji)
  const [category, setCategory] = useState(initialCategory)
  const [items, setItems] = useState(() =>
    initialItems.map(item => ({
      ...item,
      id: Date.now() + Math.random(),
      brand: item.brand || '',
      kroger_sku: item.kroger_sku || null,
      emoji: item.emoji || getItemEmoji(item),
    }))
  )
  const [search, setSearch] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [sourceUrl, setSourceUrl] = useState(initialSourceUrl)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [saving, setSaving] = useState(false)
  const [emojiPickerItem, setEmojiPickerItem] = useState(null)
  const [parsing, setParsing] = useState(false)
  const [parseError, setParseError] = useState(null)

  const emojis = [
    // Meals & dishes
    '🌮','🍝','🍔','🥘','🍕','🍗','🥗','🍜','🥙','🫕','🍳','🥞','🥣','🌯','🥪','🫔','🍱','🥩','🍖','🥚',
    // Soups & sides
    '🍲','🥗','🫛','🥜','🧆','🥔','🍠','🌽','🥦','🥕','🧅','🧄','🍅','🫑','🥒','🥬','🍄','🫚',
    // Breakfast
    '🧇','🥐','🍞','🥖','🧈','☕','🍊','🍓','🫐','🍌','🍎',
    // Seafood
    '🍣','🦐','🐟','🦞','🦀','🍤',
    // Snacks & drinks
    '🍿','🧃','🥤','🍪','🎂','🍰','🍩','🍫','🍦','🧁',
    // Misc / household
    '🛒','🧹','🧴','🧺','🧻','🥡','🍱','🫙','🏠','🎉',
  ]
  const categories = ['dinner', 'lunch', 'breakfast', 'misc', ...customTabs]

  async function searchKroger(q) {
    if (!q || q.length < 2) return
    setSearching(true)
    try {
      const res = await fetch(`/api/kroger?query=${encodeURIComponent(q)}`)
      const data = await res.json()
      const products = data.data || []
      setSearchResults(products.map(p => ({
        name: stripBrand(p.description, p.brand),
        brand: p.brand || '',
        size: p.items?.[0]?.size || '',
        price: p.items?.[0]?.price?.regular || 0,
        emoji: '🛒',
        kroger_sku: p.productId,
        image: p.images?.[0]?.sizes?.[0]?.url || null,
      })))
    } catch (err) {
      console.error(err)
    }
    setSearching(false)
  }

  async function parseRecipe() {
    if (!sourceUrl.trim()) return
    setParsing(true)
    setParseError(null)
    try {
      const res = await fetch(`/api/parse-recipe?url=${encodeURIComponent(sourceUrl.trim())}`)
      const data = await res.json()
      if (!res.ok) {
        setParseError(data.error || "Couldn't read that recipe.")
      } else {
        if (!name.trim() && data.recipeName) setName(data.recipeName)
        const newItems = (data.items || []).map(item => ({
          ...item,
          id: Date.now() + Math.random(),
          quantity: 1,
          brand: '',
          price: 0,
          kroger_sku: null,
          emoji: getItemEmoji(item),
        }))
        setItems(prev => [...prev, ...newItems])
      }
    } catch {
      setParseError("Something went wrong. Check your connection and try again.")
    }
    setParsing(false)
  }

  function addItem(item) {
    setItems(prev => [...prev, { ...item, id: Date.now(), quantity: 1, emoji: getItemEmoji(item) }])
    setSearch('')
    setSearchResults([])
  }

  function removeItem(id) {
    setItems(prev => prev.filter(i => i.id !== id))
  }

  function updateQuantity(id, delta) {
    setItems(prev => prev.map(i => i.id === id ? { ...i, quantity: Math.max(1, (i.quantity || 1) + delta) } : i))
  }

  async function saveBundle() {
    if (!name.trim() || items.length === 0) return
    setSaving(true)

    const { data: membership } = await supabase
      .from('household_members')
      .select('household_id')
      .eq('user_id', user.id)
      .single()

    if (!membership) { setSaving(false); return }

    const totalPrice = items.reduce((sum, i) => sum + (i.price || 0) * (i.quantity || 1), 0)

    const { data: maxData } = await supabase
      .from('bundles')
      .select('sort_order')
      .eq('household_id', membership.household_id)
      .eq('category', category)
      .order('sort_order', { ascending: false })
      .limit(1)
    const nextSortOrder = (maxData?.[0]?.sort_order ?? -1) + 1

    const { data: newBundle } = await supabase
      .from('bundles')
      .insert({
        name: name.trim(),
        emoji,
        category,
        bg: '#F5F5F5',
        items: items.length,
        price: Math.round(totalPrice),
        household_id: membership.household_id,
        created_by: user.id,
        is_popular: false,
        source_url: sourceUrl.trim() || null,
        sort_order: nextSortOrder,
      })
      .select()
      .single()

    if (newBundle) {
      await supabase.from('bundle_items').insert(
        items.map(item => ({
          bundle_id: newBundle.id,
          name: item.name,
          brand: item.brand,
          size: item.size,
          price: item.price,
          emoji: item.emoji || '🛒',
          quantity: item.quantity || 1,
          kroger_sku: item.kroger_sku || null,
        }))
      )
      onSaved && onSaved(newBundle)
    }
    setSaving(false)
  }

  const total = items.reduce((sum, i) => sum + (i.price || 0) * (i.quantity || 1), 0)
  const canSave = name.trim().length > 0 && items.length > 0

  return (
    <div style={styles.container}>
      <div style={styles.navBar}>
        <button style={styles.backBtn} onClick={onBack}>← Back</button>
        <div style={styles.navTitle}>New bundle</div>
        <button
          style={{ ...styles.saveBtn, ...(canSave ? {} : styles.saveBtnDim) }}
          onClick={saveBundle}
          disabled={!canSave || saving}
        >
          {saving ? '…' : 'Save'}
        </button>
      </div>

      {/* Name + emoji */}
      <div style={styles.nameRow}>
        <div style={{ position: 'relative' }}>
          <button
            style={styles.emojiBtn}
            onClick={() => setShowEmojiPicker(p => !p)}
            type="button"
          >
            {emoji}
          </button>
          {showEmojiPicker && (
            <div style={styles.emojiGrid}>
              {emojis.flat().map((e, i) => (
                <button
                  key={i}
                  style={{ ...styles.emojiOption, ...(emoji === e ? styles.emojiOptionActive : {}) }}
                  onClick={() => { setEmoji(e); setShowEmojiPicker(false) }}
                  type="button"
                >
                  {e}
                </button>
              ))}
            </div>
          )}
        </div>
        <input
          style={styles.nameInput}
          placeholder="Name your bundle…"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </div>

      {/* Category */}
      <div style={styles.catRow}>
        {categories.map(cat => (
          <button
            key={cat}
            style={{ ...styles.catBtn, ...(category === cat ? styles.catBtnActive : {}) }}
            onClick={() => setCategory(cat)}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      {/* Source URL */}
      <div style={styles.sourceRow}>
        <span style={styles.sourceIcon}>🔗</span>
        <input
          style={styles.sourceInput}
          placeholder="Paste a recipe URL to auto-fill ingredients…"
          value={sourceUrl}
          onChange={e => { setSourceUrl(e.target.value); setParseError(null) }}
          type="url"
        />
        {sourceUrl.length > 4 && (
          <button
            style={{ ...styles.parseBtn, ...(parsing ? styles.parseBtnLoading : {}) }}
            onClick={parseRecipe}
            disabled={parsing}
          >
            {parsing ? 'Reading…' : 'Import'}
          </button>
        )}
      </div>
      {parseError && <div style={styles.parseError}>{parseError}</div>}

      {/* Search */}
      <div style={styles.searchWrap}>
        <div style={styles.searchRow}>
          <input
            style={styles.searchInput}
            placeholder="Search products…"
            value={search}
            onChange={e => {
              setSearch(e.target.value)
              searchKroger(e.target.value)
            }}
          />
          {searching && <span style={styles.searchSpinner}>…</span>}
        </div>

        {(searchResults.length > 0 || (search.length >= 2 && !searching)) && (
          <div style={styles.results}>
            <div style={styles.manualRow} onClick={() => addItem({ name: search, brand: '', size: '', price: 0, emoji: '🛒', kroger_sku: null })}>
              <div style={styles.resultInfo}>
                <div style={styles.resultName}>Add "{search}" manually</div>
                <div style={styles.resultMeta}>No price · custom item</div>
              </div>
              <button style={styles.resultAdd}>+</button>
            </div>
            {searchResults.map((item, i) => (
              <div key={i} style={styles.resultRow} onClick={() => addItem(item)}>
                <div style={styles.resultInfo}>
                  <div style={styles.resultName}>{item.name}</div>
                  <div style={styles.resultMeta}>{item.brand} · {item.size}</div>
                </div>
                <div style={styles.resultPrice}>
                  ${item.price?.toFixed(2)}
                </div>
                <button style={styles.resultAdd}>+</button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Added items */}
      <div style={styles.content}>
        {items.length === 0 ? (
          <div style={styles.emptyItems}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>🔍</div>
            <div style={styles.emptyTitle}>Search for items above</div>
            <div style={styles.emptySub}>Type any ingredient or product to search your store</div>
          </div>
        ) : (
          items.map(item => (
            <div key={item.id}>
              <div style={styles.itemRow}>
                <button
                  style={{ ...styles.itemEmoji, cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                  onClick={() => setEmojiPickerItem(prev => prev === item.id ? null : item.id)}
                >{getItemEmoji(item)}</button>
                <div style={styles.itemInfo}>
                  <div style={styles.itemName}>{item.name}</div>
                  <div style={styles.itemMeta}>{item.brand} · {item.size}</div>
                </div>
                <div style={styles.qtyControl}>
                  <button style={styles.qtyBtn} onClick={() => updateQuantity(item.id, -1)}>−</button>
                  <span style={styles.qtyNum}>{item.quantity || 1}</span>
                  <button style={styles.qtyBtn} onClick={() => updateQuantity(item.id, 1)}>+</button>
                </div>
                <div style={styles.itemPrice}>${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</div>
                <button style={styles.removeBtn} onClick={() => removeItem(item.id)}>✕</button>
              </div>
              {emojiPickerItem === item.id && (
                <div style={styles.emojiPicker}>
                  {ITEM_EMOJIS.map(e => (
                    <button
                      key={e}
                      style={styles.emojiPickerOption}
                      onClick={() => { setItems(prev => prev.map(i => i.id === item.id ? { ...i, emoji: e } : i)); setEmojiPickerItem(null) }}
                    >{e}</button>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {/* Bottom bar */}
      {canSave && (
        <div style={styles.bottomBar} onClick={saveBundle}>
          <div>
            <div style={styles.barMain}>Save "{name}"</div>
            <div style={styles.barSub}>{items.length} items · ~${total.toFixed(2)}</div>
          </div>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3 9l4 4 8-8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    maxWidth: '430px',
    margin: '0 auto',
    minHeight: '100vh',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: "'DM Sans', sans-serif",
  },
  navBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px 10px',
    flexShrink: 0,
  },
  backBtn: {
    fontSize: '13px', color: '#1D9E75',
    background: 'none', border: 'none', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
  },
  navTitle: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '18px', color: '#1a1a18',
  },
  saveBtn: {
    fontSize: '13px', fontWeight: '500', color: '#1D9E75',
    background: 'none', border: 'none', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
  },
  saveBtnDim: { color: '#ccc', cursor: 'default' },
  nameRow: {
    display: 'flex', gap: '10px', alignItems: 'center',
    padding: '0 20px 12px', flexShrink: 0,
  },
  emojiBtn: {
    fontSize: '24px', width: '52px', height: '52px',
    borderRadius: '12px', border: '0.5px solid #eee',
    background: '#f9f9f7', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  emojiGrid: {
    position: 'absolute',
    top: '56px', left: 0,
    width: '220px',
    maxHeight: '200px',
    overflowY: 'auto',
    background: 'white',
    border: '0.5px solid #eee',
    borderRadius: '14px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '8px',
    gap: '2px',
    zIndex: 100,
  },
  emojiOption: {
    width: '36px', height: '36px',
    fontSize: '20px',
    background: 'none', border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  emojiOptionActive: {
    background: '#E1F5EE',
  },
  nameInput: {
    flex: 1, padding: '12px 14px',
    borderRadius: '12px', border: '0.5px solid #1D9E75',
    fontFamily: "'DM Serif Display', serif",
    fontSize: '18px', color: '#1a1a18',
    background: 'white', outline: 'none',
  },
  catRow: {
    display: 'flex', gap: '6px',
    padding: '0 20px 12px', flexShrink: 0,
  },
  catBtn: {
    padding: '6px 12px', borderRadius: '20px',
    border: '0.5px solid #ddd', background: '#f9f9f7',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '12px', color: '#888', cursor: 'pointer',
  },
  catBtnActive: {
    background: '#1D9E75', borderColor: '#1D9E75', color: 'white',
  },
  sourceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0 20px 12px',
    flexShrink: 0,
  },
  sourceIcon: { fontSize: '14px', flexShrink: 0 },
  sourceInput: {
    flex: 1,
    padding: '10px 12px',
    borderRadius: '10px',
    border: '0.5px solid #ddd',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '13px',
    color: '#1a1a18',
    background: '#f9f9f7',
    outline: 'none',
  },
  parseBtn: {
    flexShrink: 0,
    padding: '8px 12px',
    borderRadius: '10px',
    border: 'none',
    background: '#1D9E75',
    color: 'white',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
  },
  parseBtnLoading: {
    background: '#aaa',
    cursor: 'default',
  },
  parseError: {
    margin: '-4px 20px 8px',
    fontSize: '12px',
    color: '#c0392b',
    lineHeight: '1.4',
  },
  searchWrap: {
    padding: '0 20px', flexShrink: 0, position: 'relative',
  },
  searchRow: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: '#f9f9f7', border: '0.5px solid #ddd',
    borderRadius: '12px', padding: '10px 14px',
    marginBottom: '4px',
  },
  searchInput: {
    flex: 1, background: 'none', border: 'none', outline: 'none',
    fontFamily: "'DM Sans', sans-serif", fontSize: '14px', color: '#1a1a18',
  },
  searchSpinner: { color: '#aaa', fontSize: '16px' },
  results: {
    background: 'white', border: '0.5px solid #eee',
    borderRadius: '12px', overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    maxHeight: '280px', overflowY: 'auto',
    marginBottom: '8px',
  },
  manualRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '10px 14px', borderBottom: '0.5px solid #e8f5f0',
    cursor: 'pointer', background: '#f4fbf8',
  },
  resultRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '10px 14px', borderBottom: '0.5px solid #f5f5f5',
    cursor: 'pointer',
  },
  resultInfo: { flex: 1, minWidth: 0 },
  resultName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  resultMeta: { fontSize: '11px', color: '#888' },
  resultPrice: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', flexShrink: 0 },
  resultAdd: {
    width: '26px', height: '26px', borderRadius: '50%',
    border: '0.5px solid #ddd', background: '#f9f9f7',
    fontSize: '16px', color: '#888', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    flex: 1, overflowY: 'auto', padding: '8px 20px',
  },
  emptyItems: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    textAlign: 'center', padding: '40px 20px',
  },
  emptyTitle: { fontSize: '14px', fontWeight: '500', color: '#1a1a18', marginBottom: '6px' },
  emptySub: { fontSize: '12px', color: '#888', lineHeight: '1.5' },
  itemRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '9px 0', borderBottom: '0.5px solid #eee',
  },
  itemEmoji: { fontSize: '20px', width: '28px', textAlign: 'center', flexShrink: 0 },
  itemInfo: { flex: 1, minWidth: 0 },
  itemName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18' },
  itemMeta: { fontSize: '11px', color: '#888' },
  qtyControl: { display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 },
  qtyBtn: {
    width: '22px', height: '22px', borderRadius: '6px', border: '0.5px solid #ddd',
    background: '#f9f9f7', fontSize: '14px', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#1a1a18', fontFamily: "'DM Sans', sans-serif",
  },
  qtyNum: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', minWidth: '16px', textAlign: 'center' },
  itemPrice: { fontSize: '12px', color: '#888', flexShrink: 0 },
  removeBtn: {
    width: '22px', height: '22px', borderRadius: '50%',
    border: '0.5px solid #ddd', background: '#f9f9f7',
    fontSize: '11px', color: '#aaa', cursor: 'pointer',
    flexShrink: 0,
  },
  emojiPicker: {
    display: 'flex', flexWrap: 'wrap', gap: '2px',
    padding: '8px', background: 'white',
    border: '0.5px solid #eee', borderRadius: '12px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
    marginBottom: '4px',
  },
  emojiPickerOption: {
    width: '34px', height: '34px', fontSize: '18px',
    background: 'none', border: 'none', borderRadius: '8px',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  bottomBar: {
    margin: '6px 20px 14px', padding: '13px 18px',
    background: '#1D9E75', borderRadius: '14px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    cursor: 'pointer', flexShrink: 0,
  },
  barMain: { fontSize: '13px', fontWeight: '500', color: 'white' },
  barSub: { fontSize: '11px', color: 'rgba(255,255,255,0.8)' },
}